<template>
    <div class="ve-list-page">
        <div style=" background:white;line-height:30px;border-bottom:2px solid #389"> 
            <div style="padding-top:3px;display:flex;width:1400px; ">
                <div style="width:90px">
                    <i class="iconfont icon-xinzeng" style="color:#409EFF;font-size:14px;margin-right:5px;margin-left:8px;"></i>
                    <el-link :disabled="addBool" @click="addRec" :underline="false" style="margin-top:0px;"><span style="font-size:13px; ">{{ $LANG('0138', '新增') }} </span></el-link>
                </div>
                <div style="margin-right:10px;font-size:12px;margin-left:5px;">{{ $LANG('0358', '状态') }}</div>
                <el-select v-model="stfgSet"  size="small" @change="stfgChange" style="width:95px">
                    <el-option :label="$LANG('0321', '所有')" value="ALL"></el-option>
                    <el-option :label="$LANG('2005', '未审核')" value="N"></el-option>
                    <el-option :label="$LANG('1976', '已审核')" value="Y"></el-option>
                </el-select>
                <span style=" margin-left:20px;font-size:12px;margin-right:10px;">{{ $LANG('0681', '字段查询') }}</span>
                <el-select v-model="selparam" size="small" :placeholder="$LANG('1675', '请选择列名')" clearable  style="width:150px; " >
                    <span v-for="item in mainCol" :key='item.key'>
                        <el-option :label="$translate.getColTitle(item, $store.state.lang)" :value="item.key" v-if="item.thide=='N' "></el-option>
                    </span>
                </el-select>
                <el-input :placeholder="input_hold" v-model="txtparam" @keyup.enter.native="stfgChange" size="small" style="width:320px; height:30px; ">
                    <el-select v-model="oper" slot="prepend"   style="width:100px; " >
                        <span v-for="item in operArr" :key='item.IDSEQ'>
                            <el-option :label="item.CNAME" :value="item.SUBNO"></el-option>
                        </span>
                    </el-select>
                    <el-button size="small" slot="append" icon="el-icon-search" @click="stfgChange" ></el-button>
                </el-input> 
                <el-select v-model="selparam2" size="small" :placeholder="$LANG('1675', '请选择列名')" clearable  style="width:150px; " >
                    <span v-for="item in mainCol" :key='item.key'>
                        <el-option :label="$translate.getColTitle(item, $store.state.lang)" :value="item.key" v-if="item.thide=='N'"></el-option>
                    </span>
                </el-select>
                <el-input :placeholder="input_hold" v-model="txtparam2" @keyup.enter.native="stfgChange" size="small" style="width:320px; height:30px; ">
                    <el-select v-model="oper2" slot="prepend"   style="width:100px; " >
                        <span v-for="item in operArr" :key='item.IDSEQ'>
                            <el-option :label="item.CNAME" :value="item.SUBNO"></el-option>
                        </span>
                    </el-select>
                    <el-button size="small" slot="append" icon="el-icon-search" @click="stfgChange" ></el-button>
                </el-input>
                <i class="iconfont icon-ziyuan" style="color:#409EFF;font-size:14px;margin:0 5px 0 15px;"></i>
                <el-link @click="openFieldSettingsDialog().catch(() => {})" :underline="false"><span style="font-size:12px;margin-right:15px;">{{ $LANG('0683', '字段设置') }}</span></el-link>
            </div>
        </div>
        <div class="ve-list-page__table">
        <ve-table :columns="vueCol"
              :table-data="poData"
              v-loading="loading"
              :border-around="true"
              :border-x="true"
              :border-y="true"
              :fixed-header="true"
              row-key-field-name="IDSEQ"
              :row-style-option="rowStyleOption"
              :cell-style-option="cellStyleOption"
              :event-custom-option="eventCustomOption"
              :max-height="subHeight"
              :scroll-width="0"
              :column-width-resize-option="columnWidthResizeOption"
              :cellSelectionOption="{enable: false}"
              :element-loading-text="$LANG('1959', '加载中')"
              ref="refreq">
        </ve-table>
        </div>
        <!-- 分页查询 -->
        <div class="ve-list-page__pagination">
            <div style="float: left;padding-left:4px;font-size:12px;">
                <Page :total="dataCount" :page-size="rowSize" show-total :current="current" @on-change="changePage"></Page>
            </div>
            <div style="line-height:30px;height:35px;width:500px;display:flex ; ">
                <div style="color:#606266; font-size:12px;width:35px;margin-left:15px">{{ $LANG('0349', '每页') }}</div>
                <el-select v-model="rowSize" size="small" style="width:70px;"  @change="initPage">
                    <el-option 
                        v-for="item in pageList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                    </el-option>
                </el-select>
                <div style="color:#606266; margin-left:10px;font-size:12px;width:30px;">{{ $LANG('0398', '跳至') }}</div>
                <el-input v-enter-number size="small" v-model="goPage" style="width:50px;"></el-input> 
                <span style="color:#606266; font-size:12px;margin-left:4px">{{ $LANG('1660', '页') }}</span>
                <el-button @click="goNext" size="small" type="primary" style="width:40px;margin-left:15px;height:32px;">GO</el-button>
            </div>
        </div>
        <!-- 提示框 -->
        <el-dialog :show-close="false" :visible.sync="promptWin" width="400px" append-to-body :close-on-click-modal="false" :close-on-press-escape="false" >
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'35px'}">
                <span style="line-height:35px;height:35px;font-size:14px;padding-left:5px;">{{ $LANG('1442', '提示') }}</span>
            </div>
            <div style="line-height:30px;display:flex">
                <div style="width:40px; "><i class="iconfont icon-tishi1" style="color:#5cadff;font-size:36px"></i></div>
                <div style="font-size:12px;line-height:30px; ">{{prompt}}</div>
            </div>
            <div slot="footer">
                <Button type="primary"   @click="promptWin=false" style="margin-right:20px;">{{ $LANG('1638', '确定') }}</Button>
            </div>
        </el-dialog>
        <!-- 新增、编辑表单 -->
        <el-dialog class="pub_dialog" v-dialogDrag  :visible.sync="addWin" :width="tabWidth" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="4vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:36px;height:36px;font-size:15px;padding-left:5px;"><i class="iconfont icon-xuanze" style="margin-right:5px"></i>{{$route.meta.title}} ：{{ $LANG('0109', '明细资料') }}</span>
            </div> 
            <div style="height:88vh;overflow-y:auto">
                <Form :model="poRow" :label-width="110" ref="dtlform"  label-position="right" inline  :rules="ruleValidate">  
                    <span v-for="(item,index) in mainCol" :key="index" >
                        <FormItem   :label="$translate.getColTitle(item, $store.state.lang)"  :class=" item.edcss=='textarea'?'item-one':'item-width'" v-if="item.fhide==='N'" :prop="item.key"  >
                            <el-date-picker size="medium" :disabled="saveFlag" type="date"  v-if="item.edcss==='date'" v-model="poRow[item.key]" clearable value-format="yyyy-MM-dd" style="width:100%" ></el-date-picker>   
                            <el-input-number size="medium" :disabled="saveFlag||item.disabled==='Y'" :precision="item.dotnum"  v-else-if="item.edcss==='number'" v-model="poRow[item.key]" style="width:100%" ></el-input-number>   
 
                            <el-select size="medium" filterable  :disabled="saveFlag" v-else-if="item.key==='MATTY' "  style="width:100%" :placeholder="$LANG('1664', '请选择')" v-model="poRow[item.key]" >
                                <el-option v-for="(item,index) in tyArr"   :key="index" :value="item.SUBNO" :label="item.CNAME"  >   </el-option>
                            </el-select>
                            <el-input size="medium" :disabled="saveFlag" @focus="inputBtn('','', item.key)" v-else-if="item.edcss=='button'"   v-model="poRow[item.key]" style="width:100%"> </el-input>  
                            <el-select size="medium" :disabled="saveFlag" v-else-if="item.edcss==='select'" v-model="poRow[item.key]" clearable  style="width:100%">
                                <el-option v-for="(item,index) in comboArr[item.key]" :key="index" :label="item.CNAME" :value="item.CODE"></el-option>
                            </el-select>
                            <el-input resize="none" :disabled="saveFlag" v-else-if="item.edcss==='textarea'" type="textarea" :rows="4"  :placeholder="$LANG('1670', '请输入内容')" v-model="poRow[item.key]" maxlength="1000" show-word-limit ></el-input>
                            <el-input size="medium" :placeholder="item.holder" :disabled="saveFlag ||item.disabled==='Y'?true:false" type="text" v-else   v-model="poRow[item.key]" ></el-input>
                        </FormItem>
                    </span>
                </Form>
 
 
            </div>
            <div style="height:40px;line-height:30px;border-top:2px solid #ccc;padding-top:4px; " >
                <span style="float:right">
                    <i class="web-font" style="font-size:14px;margin-right:20px;color:#ed4014;font-weight:600">{{ $LANG('1496', '提示：单据审核后不能再编辑 ， 如需编辑请弃审') }}</i>
                    <span style="margin-right:30px">
                        <i v-if="poRow['STFG']==='N'" style="margin-left:20px; color:red;font-size:28px; " class="iconfont icon-weishenhe3"> </i>
                        <i v-else-if="poRow['STFG']==='Y'" style="margin-left:20px; color:red;font-size:28px; " class="iconfont icon-yishenhe1"> </i>
                        <i v-else-if="poRow['STFG']==='X'" style="margin-left:20px; color:red;font-size:28px; " class="iconfont icon-yizuofei"> </i>
                    </span>
                    <el-button type="info" size="small" icon="iconfont icon-shanchu"  @click="addWin=false" style="margin-right:25px;">{{ $LANG('0132', '取消') }}</el-button>
                    <el-button :disabled="addBool||saveFlag"  type="primary" size="small" icon="iconfont icon-baocun"  @click="saveRec" style="margin-right:10px;">{{ $LANG('0130', '保存') }}</el-button>
                </span>
            </div>
        </el-dialog>
         <!-- 引用选择框 -->
        <el-dialog  v-dialogDrag   :visible.sync="btnWin" :width="tabWidth" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="4vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">{{ $LANG('0997', '选择记录') }}</span>
            </div> 
            <pub-win v-bind:tabCol ="tableCol"  v-bind:v_table="v_table" v-bind:v_key2="v_key2" v-bind:v_value2="v_value2" @child-exit="btnWin=false" @child-sure="btnSure"></pub-win>                
        </el-dialog>
        <!-- report preview -->
        <el-dialog class="pub_dialog" v-dialogDrag  :visible.sync="repWin" :width="tabWidth" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="4vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">{{ $LANG('0063', '报表预览') }}</span>
            </div> 
            <div style="height:88vh;overflow-y:auto">
                <iframe :src="repUrl" frameborder="0" style="width: 100%; height: 100%"></iframe>
            </div>
        </el-dialog>
        <!-- 引用报表 -->
        <el-dialog  v-dialogDrag   :visible.sync="repDlg" width="550px" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="6vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">{{ $LANG('0059', '报表参数') }}</span>
            </div> 
            <rep-win v-bind:v_idno ="v_idno" v-bind:v_replist="v_replist" v-bind:v_corpid="v_corpid" @child-exit="repDlg=false" @child-sure="repShow"></rep-win>                
        </el-dialog> 
        <VeColumnConfigDialog
            :visible="fieldSettingDialog.visible"
            :rows="fieldSettingDialog.rows"
            :loading="fieldSettingDialog.loading"
            :error="fieldSettingDialog.error"
            :locked-field-keys="fieldSettingDialog.lockedFieldKeys"
            :drag-group-field="fieldSettingDialog.dragGroupField"
            :language="$store.state.lang"
            @update:visible="fieldSettingDialog.visible = $event"
            @change="updateFieldSettingsDraft"
            @confirm="saveFieldSettingsDialog"
            @reset="resetFieldSettingsDialog"
            @close="closeFieldSettingsDialog"
        />
    </div>
</template>
<script>
import {getBaseData,getTabColOrData} from '../../api/user'; 
import { getDate} from '../../api/Select' 
import pubWin from '../datamgt/pubwin.vue'  
import repWin from '../datamgt/repWin.vue' 
import createVeTableFieldSettingMixin from '@/utils/veTableFieldSettingMixin'
import VeColumnConfigDialog from '@/components/VeTable/VeColumnConfigDialog.vue'
import VeTableQueryHeader from '@/components/VeTable/VeTableQueryHeader.vue'
import { buildVeTableFieldCondition, buildVeTableHeaderCondition, isVeTableMetadataField } from '@/utils/veTableHeaderQuery'
export default {
    name:'clnt_research',
    mixins: [
        createVeTableFieldSettingMixin({
            settingFormId: '421634',
            fieldIdseq: '421634',
            fieldLstseq: '1',
            mainColumnKey: 'mainCol',
            tableColumnKey: 'vueCol',
            initColumnKey: 'initCol',
            tableRef: 'refreq',
            generatedFixedColumnKeys: ['rownum', 'oper'],
        })
    ],
    data () {
        return {
            sendVal:'PRD',
            v_table:'',
            tableCol :[],
            v_key2 :'',
            v_value2 :'',
            toolFlag:false,
            qryCond:'',
            v_random:'',
            dtlRow:{},
            v_tabRow:{},
            v_tabIndex:'',
            chkIndex: 0,
            stfgBool:true,
            appBool:false,
            v_commit :true,
            promptWin:false,
            prodCol:[],
            dtlFlag:'create',
            prdRow:{},
            supFlag:'',
            addFlag:'create',
         
            rowDtl:{},
            btnWin:false,
            stfgSet:'ALL',
            tyArr:[],
            prompt:'',
            input_hold:this.$LANG('1670', '请输入内容...'),
            ruleValidate:{},
            selparam:'IDNO',
            txtparam:'',
            poRow:{},
            prdFlag:'create',
            goPage:'',
            rowIdseq:'',
            poData:[],
            cfmBool:false, //审核 权限
            addBool:false, //新增 权限
            editBool:false, //编辑权限
            v_admin:this.$cookies.get('v_admin') , 
            loading:false,
            current:1,
            saveFlag:false,
            allList:[], //询价单集合
            dtlData:[],
            matData:[],
            addWin:false,
            v_username:this.$cookies.get('v_telno'), //api 请求用户
            
            v_corpid:this.$cookies.get('v_corpid') , //员工公司ID
            v_url:'xuper_auth/getTableRecMany', //api请求路径   
            pageList: [{
                value: 50,
                label: '50'
                }, {
                value: 100,
                label: '100'
            }],
            selparam2:'',
            txtparam2:'',
            oper2:'like',
            dataCount:0,
            rowSize:50,
     
            matCol:[],
            mainCol:[],
            initCol:[],
            vueCol:[],
            rowStyleOption: { clickHighlight: true },
            cellStyleOption: {
                headerCellClass: () => 'table-head-cell-class',
                bodyCellClass: () => 'table-body-cell-class1',
            },
            eventCustomOption: {
                bodyRowEvents: ({ row }) => ({ click: () => this.rowClick(row) }),
            },
            operArr:[],
            prcCol:[],
            prcData:[],
            prdIndex:'',
            oper:'like',
            v_key:'',
            v_idseq:this.$cookies.get('idseq'),
            dtlIndex:'',
            comboArr:[],
            cltCol:[],
            v_usernm:this.$cookies.get('v_usernm'), //api 请求用户
            repWin:false,
            repUrl:'',
            repDlg:false,
            v_idno:'',
            v_replist:[],
            repArr:[],
            v_row:{},
            headerSortKey:'',
            headerSortOrder:'',
            queryRequestId:0,
        }
    },
    components: {
      pubWin,  
      repWin,
      VeColumnConfigDialog,
      // JSX query headers are resolved at runtime.
      // eslint-disable-next-line vue/no-unused-components
      VeTableQueryHeader,
   
    },
    computed: {
        subHeight: function() {
            return (window.innerHeight - 162) + 'px';
        }, 
        dtlHeight: function() {
            return (window.innerHeight - 290) + 'px';
        }, 
        tabWidth: function() {
            return (window.innerWidth - 140) + 'px';
        },
    },
    mounted () {
        //操作符
        getBaseData(his.v_url+'','PARENTNO','15995','','','v_sys_base','').then(res=>{
            this.operArr =res.result
        }) 
 
        getBaseData(this.v_url,'userno',this.v_username,'frmidseq','421634','V_USER_MOD_REP','').then(res=>{
            this.repArr =res.result
        })
        getBaseData(his.v_url+'','PARENTNO','16224','','','v_sys_base','').then(res=>{
            this.tyArr =res.result
        }) 
         //用户权限表
        getBaseData(this.v_url,'userno',this.v_username,'frmidseq','421634','v_sys_user_priv','').then(res=>{           
            if (this.v_admin==='N') { //表示有权限控制
                let row =res.result[0]
                if (row.ISADD==='N'){ //新增
                    this.addBool=true
                }if (row.ISUPD==='N'){ //修改
                    this.editBool=true
                }if (row.ISDEL==='N'){ //删除
                    this.delBool=true
                }if (row.ISCFM==='N'){ //审核
                    this.cfmBool=true
                }if (row.ISEXP==='N'){ //确认
                    this.appBool=true
                }
            }
        })    
         //动态生成表单验证规则
        getTabColOrData(this.v_url,'v_sys_form_fld','idseq','421634','LSTSEQ','1','NOTNULL','Y').then((res) => {
            let ruleObj={}
            let ruleVal=[]
            this.notNull = res.result
            res.result.forEach(item => {
                let v_fldnm =item.FLDNM
                let obj1={required:true,message:v_fldnm+this.$LANG('2051', '不能为空'),trigger: 'blur'}
                ruleVal =[]
                ruleVal.push(obj1)
                ruleObj[item.FLDNO]=ruleVal                  
            });
            this.ruleValidate =ruleObj
        });
    },
    created () {
        if (this.v_username){
            this.getTabCol() //表列集合
            this.getPoList('') //询价单主数据   
            this.comSelect() 
        }else{
            let routeUrl = this.$router.resolve({
                path: '/',
                query: {lang:this.LANG },
            });
            window.open(routeUrl.href, '_self'); 
        }
    },
    methods: {
        //报表运行
        repBtn(row){
            this.repDlg =true
            this.v_idno =row['IDNO']
            this.v_replist =this.repArr
        },
        repShow(row){
            if (!row['REPNO']){
                this.promptWin =true
                this.prompt =this.$LANG('1678', '请选择报表')
            }else{
                this.repWin =true
                this.repDlg =false
                this.repUrl =this.$store.state.repUrl+ row['REPNO']+'&p_corpid='+row['CORPID']+'&p_idno='+row['IDNO'] 
            }
        },
 
        btnSure(obj){
            if (this.v_key=='MATNO'){
                Object.assign(this.poRow,{ MATNO:obj['IDNO'],MATNM:obj['MATNM'],MATDESC:obj['MATDESC']  })     
            }else if (this.v_key=='CLNTNO'){
                Object.assign(this.poRow,{ CLNTNO:obj['IDNO'],CLNTNM:obj['CLNTNM'] })     
            }
            this.btnWin =false
        },
        inputBtn(row,index, key){   
            this.v_key =key     
            if (key =='MATNO'){    
                if (this.poRow['MATTY']){
                    this.v_random=Math.random()  
                    this.v_key =key  
                    this.v_table ='v_BS_MAT'
                    this.tableCol =this.prodCol
                    this.v_key2 ='modelno'
                    this.v_value2 = this.poRow['MATTY']
                    this.t_cond=''
                    this.btnWin =true
                }else{
                    this.promptWin =true
                    this.prompt =this.$LANG('1682', '请选择类型')
                }
            }else if (key=='CLNTNO'){
                this.v_random=Math.random()  
                this.v_table ='v_BS_clnt'
                this.tableCol =this.cltCol
                this.v_key2 =''
                this.v_value2 = ''
                this.t_cond=''
                this.btnWin =true
            }
        },
 
 
        //动态赋值下拉框
        comSelect(){  
            this.$axios({
                method:'post', 
                url: 'xuper_auth/getBaseData' ,
                data:{p_table:'v_sys_form_fld',p_key:'idseq',p_value:'421634',p_cond:' and lstseq in (1,2)',p_key2:'edcss',p_value2:'select'},
            }).then(res =>{
                if (res.result.length>0){
                    for(let k=0;k<res.result.length;k++){
                        getBaseData('xuper_auth/getBaseData','parentno',res.result[k].COMBO ,'','','v_sys_base','').then(res2=>{
                            this.comboArr[res.result[k].FLDNO] =res2.result
                        })
                    }
                }
            })  
        },
 
        //编辑记录
        editRec(row,val,index){
            if (val==='Y'){  //仅查看
                this.saveFlag=true
            }else{
                if (row.STFG==='Y'){
                    this.saveFlag=true
                }else{
                    this.saveFlag=false
                }   
            }
            this.addFlag='edit'
            this.poRow =JSON.parse(JSON.stringify(Object.assign(row,{IDSEQ:row.IDSEQ})))
            this.rowIdseq=row.IDSEQ
 
            this.addWin=true   
            this.v_commit =true   
        },
        //保存记录
        saveRec(){
            this.notNull.some(item=>{  //forEach 没找到跳出循环，some：return true 跳出lop ,every：return false 跳出
                if (!this.poRow[item.FLDNO] ){
                    this.stfgBool =false 
                    this.promptWin=true
                        this.prompt=item.FLDNM+this.$LANG('2051', '不能为空')
                    return true
                }else{
                    this.stfgBool =true  
                }
            })
            //发起保存请求   
            if (this.stfgBool &&this.v_commit) { 
                this.v_commit =false
 
                this.$axios({
                    method: 'post',
                    url:'xuper_auth/formOneSave',
                    data: {p_json:JSON.stringify(Object.assign(this.poRow,{CORPID:this.v_corpid })), p_table:'CLNT_FEED',frmid:'421634'},
                }).then(res=>{      
                    if(res.result ==='OK')  {  
                        let idseq_ =res.idseq

                        this.addWin =false   
                        this.getPoList('')
                    }else{
                        this.promptWin=true
                        this.prompt=res.result
                    }        
                }) 
 
            }
        },
        //新增
        addRec(){
            this.addWin=true
            this.poRow={DTTM:getDate('day'),'IDSEQ':'',STFG:'N' ,'MATTY':'PRD' }
            this.dtlData=[]
            this.saveFlag=false
            this.v_commit =true
        },
 
        getRowKey(row){
            return row.IDSEQ
        },
        getDtlKey(row){
            return row.index
        },
        tabRowClass({row,rowIndex}){  //为 table数据添加 index 字段
            row.index =rowIndex
        },
        rowClick(row){
            this.chkIndex =row.index
        },
         //状态变更
        stfgRec(row,val,index,v_comm){
            let v_cond ='' ,v_chkdttm='',v_chkuser='',v_cfmdttm='',v_cfmuser=''
            if (val =='Y'){
                v_chkdttm =getDate('full')
                v_chkuser =this.v_usernm
                v_cond =' set stfg=\''+val+'\',chkuser=\''+v_chkuser+'\',chkdttm=\''+v_chkdttm+'\''
            }else{
                v_chkuser='',v_chkdttm='',v_cfmuser='',v_cfmdttm=''
                v_cond =' set stfg=\''+val+'\',chkuser=\''+v_chkuser+'\',chkdttm=\''+v_chkdttm+'\''
            }
            this.$confirm(this.$LANG('1564', '你确定要')+v_comm+this.$LANG('1565', '此单据吗?'),this.$LANG('1442', '提示'),{
                confirmButtonText: this.$LANG('1638', '确定'),
                cancelButtonText:this.$LANG('0132', '取消'),
                customClass:'messageBox',
                showClose:false,
                type:'info',
            }).then(()=>{
                var vm=this;
                this.$axios({
                    method: 'post',
                    url:'xuper_auth/updateRec',
                    data: {p_key:'idseq',p_value:row.IDSEQ,p_table:'CLNT_FEED',p_cond: v_cond},
                }).then(res=>{      
                    if(res.code =='200')  {  
                        if (val =='X'){
                            this.poData.splice(index,1)
                        } else{        
                            if (val =='Y'){
                                Object.assign(row,{STFGNM:v_comm ,STFG:val, CHKUSER:v_chkuser,CHKDTTM:v_chkdttm})
                            }else{
                                Object.assign(row,{STFGNM:v_comm ,STFG:val, CHKUSER:'',CHKDTTM:''})
                            }
                        }
                    }    
                })
            }).catch(()=>{})           
        },
        //状态查询
        stfgChange(){
            const firstCondition =this.oper === '!=' && isVeTableMetadataField(this.initCol, this.selparam)
                ? ` and ${this.selparam} is null `
                : buildVeTableFieldCondition(this.initCol, this.selparam, this.txtparam, this.oper)
            const secondCondition =buildVeTableFieldCondition(this.initCol, this.selparam2, this.txtparam2, this.oper2)
            const headerCondition =buildVeTableHeaderCondition(this.initCol, this.v_row, {
                typeOverrides: { STFG: 'select' },
                numberOperatorDefault: '>=',
            })
            let cond_ =firstCondition+secondCondition+headerCondition
            if (this.stfgSet!=='ALL'){
               cond_=cond_+' and  stfg=\''+this.stfgSet+'\''
            }
            this.current =1
            this.getPoList(cond_)
        }, 
        rowShow(){
            this.v_row ={}
            this.current =1
            this.stfgChange()
        },
        sortHeaderColumn(column){
            const key =column && column.key
            if (!key || !isVeTableMetadataField(this.initCol, key)) return
            if (this.headerSortKey === key) this.headerSortOrder =this.headerSortOrder === 'asc' ? 'desc' : 'asc'
            else {
                this.headerSortKey =key
                this.headerSortOrder ='asc'
            }
            this.stfgChange()
        },
        goNext(){
            if (this.goPage){
                this.changePage(this.goPage)
                this.current =Number(this.goPage)
            }else{
                this.$alert(this.$LANG('1721', '请输入跳至页数'), this.$LANG('1442', '提示'), {
                    confirmButtonText: this.$LANG('1638', '确定'),
                    showClose:false,
                    type:'info'
                })
            }
        },
        //表格页面导航
        changePage(index){
            var _start = ( index - 1 ) * this.rowSize;
            var _end = index * this.rowSize
            this.current =index
            this.poData = this.allList.slice(_start,_end);
        },
        //初始化查询页条数
        initPage(){
            //产品明细
            this.dataCount =this.allList.length //总条数
            // 初始化显示，小于每页显示条数，全显，大于每页显示条数，取前每页条数显示
            if (this.allList.length < this.rowSize){
                this.poData = this.allList          
            }else{
         
                if (this.current >1){
                    this.changePage(this.current)
                }else{
                    this.poData =this.allList.slice(0,this.rowSize) //返回选定元素的子数组，不包含结尾元素
                }
            }
            this.$nextTick(() => { //有固定列时 查询后重新布局
                const table = this.$refs.refreq
                if (table && typeof table.doLayout === 'function') table.doLayout()
            }) 
        },
 
        //查询界面
        getPoList(cond){
            const requestId =++this.queryRequestId
            this.loading =true
            const orderField =isVeTableMetadataField(this.initCol, this.headerSortKey) ? this.headerSortKey : 'IDNO'
            const orderDirection =this.headerSortKey ? this.headerSortOrder : 'desc'
            getTabColOrData(this.v_url,'v_CLNT_FEED','','','CORPID',this.v_corpid,'','',`${cond} order by ${orderField} ${orderDirection}`).then((res) => {
                if (requestId !== this.queryRequestId) return
                this.allList =res.result || []
                this.initPage() 
            }).catch(error=>{
                if (requestId !== this.queryRequestId) return
                this.prompt =error.message || this.$LANG('1641', '查询失败')
                this.promptWin =true
            }).finally(()=>{
                if (requestId === this.queryRequestId) this.loading =false
            })
        },
 
        //获取表列头字段  v-enter-number
        getTabCol(){
            var vm=this
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','421634','lstseq','1','','',' order by sortby,lstseq' ).then((res) => {
                vm.initCol = res.result
                return vm.loadInitialFieldSettings().then(() => {
                    const fieldRows = vm.sortFieldRows(vm.initCol)
                    vm.mainCol = []
                    vm.vueCol = []
                    fieldRows.forEach(item => {
                        vm.mainCol.push({
                            title: vm.$translate.getColTitle(item, vm.$store.state.lang),
                            key: item.key,
                            align: item.align,
                            width: item.width,
                            thide: item.THIDE,
                            fhide: item.FHIDE,
                            edcss: item.EDCSS,
                            disabled: item.DISABLED,
                            dotnum: item.DOTNUM,
                            holder: item.HOLDER,
                            sortable: item.SORTABLE,
                        })
                        if (item.THIDE !== 'N') return
                        const column = item
                        vm.vueCol.push({
                            field: column.key,
                            key: column.key,
                            title: vm.$translate.getColTitle(column, vm.$store.state.lang),
                            type: column.EDCSS === 'checkbox' ? 'check' : column.EDCSS,
                            align: column.align,
                            width: Number(column.width) || 120,
                            sortable: false,
                            ellipsis: { showTitle: true },
                            renderHeaderCell: ({column: veColumn}) => <VeTableQueryHeader
                                title={veColumn.title}
                                edcss={column.key === 'STFG' ? 'select' : column.EDCSS}
                                value={this.v_row[column.key]}
                                operator={this.v_row[`#OPER${column.key}`]}
                                defaultOperator=">="
                                showDateOperator={false}
                                sortable={column.key !== 'RN' && column.SORTABLE === 'N' && column.EDCSS !== 'checkbox'}
                                sortOrder={this.headerSortKey === column.key ? this.headerSortOrder : ''}
                                options={column.key === 'STFG' ? [
                                    { value: 'N', label: this.$LANG('2005', '未审核') },
                                    { value: 'Y', label: this.$LANG('1976', '已审核') },
                                ] : (['select', 'checkbox'].includes(String(column.EDCSS || '').toLowerCase()) ? (this.comboArr[column.key] || []) : [])}
                                on-input={(value) => this.$set(this.v_row, column.key, value)}
                                on-operator-change={(value) => this.$set(this.v_row, `#OPER${column.key}`, value)}
                                on-title-click={() => this.sortHeaderColumn(veColumn)}
                                on-query={this.stfgChange}
                            />,
                            renderBodyCell: ({row}) => {
                                if (column.key === 'IDNO') {
                                    return (
                                        <el-link underline={false} on-click={() => vm.repBtn(row)}>
                                            <div style="color:#409eff;border-bottom:1px solid red;font-size:11px">{row[column.key]}</div>
                                        </el-link>
                                    )
                                }
                                if (column.EDCSS === 'checkbox') {
                                    return <el-checkbox disabled true-label="Y" false-label="N" v-model={row[column.key]} style="width:100%">&nbsp;</el-checkbox>
                                }
                                return <span>{row[column.key]}</span>
                            },
                        })
                    })
                    vm.vueCol.unshift({
                        field: 'index',
                        key: 'rownum',
                        title: vm.$LANG('0310', '序号'),
                        width: 60,
                        align: 'center',
                        fixed: 'left',
                        disableResizing: true,
                        renderBodyCell: ({rowIndex}) => rowIndex + 1,
                        renderHeaderCell: ({column}) => <div class="clnt-research-sequence-header"><div class="clnt-research-sequence-header__title">{column.title}</div><el-link on-click={vm.rowShow} style="font-size:12px;color:#404eff;height:30px"><el-tooltip content={vm.$LANG('0852', '清除条件')} effect="light"><i class="iconfont icon-shanchu1"></i></el-tooltip></el-link></div>,
                    })
                    vm.vueCol.push({
                        field: 'oper0',
                        key: 'oper',
                        title: vm.$LANG('0330', '状态操作'),
                        width: 210,
                        align: 'center',
                        fixed: 'right',
                        disableResizing: true,
                        renderBodyCell: ({row, rowIndex}) => (
                            <div>
                                <i class="iconfont icon-chakan" style="color:#409EFF;font-size:12px;margin-right:2px;"></i>
                                <el-link on-click={() => vm.editRec(row, 'Y', rowIndex)} underline={false}>
                                    <span style="font-size:11px;margin-right:5px">{vm.$LANG('0139', '查看')}</span>
                                </el-link>
                                {row.STFG === 'N' ? <span>
                                    <i class="iconfont icon-bianji" style="color:#409EFF;font-size:12px;margin-right:2px;"></i>
                                    <el-link on-click={() => vm.editRec(row, 'N', rowIndex)} underline={false}>
                                        <span style="font-size:11px;margin-right:5px">{vm.$LANG('1639', '编辑')}</span>
                                    </el-link>
                                </span> : null}
                                {row.STFG === 'N' ? <span>
                                    <i class="iconfont icon-shenhe" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                                    <el-link disabled={vm.cfmBool} on-click={() => vm.stfgRec(row, 'Y', rowIndex, vm.$LANG('0134', '审核'))} underline={false}>
                                        <span style="font-size:11px;margin-right:5px;">{vm.$LANG('0134', '审核')}</span>
                                    </el-link>
                                </span> : null}
                                {row.STFG === 'Y' ? <span>
                                    <i class="iconfont icon-fanshenhe" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                                    <el-link disabled={vm.cfmBool} on-click={() => vm.stfgRec(row, 'N', rowIndex, vm.$LANG('0137', '弃审'))} underline={false}>
                                        <span style="font-size:11px;margin-right:5px;">{vm.$LANG('0314', '弃审')}</span>
                                    </el-link>
                                </span> : null}
                                {row.STFG === 'N' ? <span>
                                    <i class="iconfont icon-shanchu" style="color:#409EFF;font-size:12px;margin-right:2px;"></i>
                                    <el-link on-click={() => vm.stfgRec(row, 'X', rowIndex, vm.$LANG('0257', '作废'))} underline={false}>
                                        <span style="font-size:11px;">{vm.$LANG('0257', '作废')}</span>
                                    </el-link>
                                </span> : null}
                            </div>
                        ),
                    })
                    vm.applyFieldSettingRows()
                })
            })
 
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','4272','lstseq','1','','',' order by sortby,lstseq').then((res) => {
                for (let k=0; k<res.result.length; k++){
                    vm.prodCol.push({ //向数组的开头 添加序列号
                        title: vm.$translate.getColTitle(res.result[k], vm.$store.state.lang),
                        key: res.result[k].key,
                        align: res.result[k].align,
                        width: res.result[k].width,
                        edcss:res.result[k].EDCSS,
                        sortable:res.result[k].SORTABLE,
                        thide:res.result[k].THIDE,
                        fhide:res.result[k].FHIDE,
                    })
                }
            })
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','94','lstseq','1','','',' order by sortby,lstseq').then((res) => {
                for (let k=0; k<res.result.length; k++){
                    vm.cltCol.push({ //向数组的开头 添加序列号
                        title: vm.$translate.getColTitle(res.result[k], vm.$store.state.lang),
                        key: res.result[k].key,
                        align: res.result[k].align,
                        width: res.result[k].width,
                        thide:res.result[k].THIDE,
                        fhide:res.result[k].FHIDE,
                        edcss:res.result[k].EDCSS,
                        disabled:res.result[k].DISABLED,
                        sortable:res.result[k].SORTABLE,
                    })
                }
            })
        },
    }
}
</script>
<style scoped lang="less">
    .ve-list-page {
        display: flex;
        flex-direction: column;
        height: calc(100% - 32px);
        min-height: 0;
        overflow: hidden;
        background: white;
    }
    .ve-list-page__table {
        flex: 1 1 auto;
        min-height: 0;
        overflow: hidden;
    }
    .ve-list-page__table > .vue-table-root {
        height: 100%;
    }
    .ve-list-page__table /deep/ .ve-table,
    .ve-list-page__table /deep/ .ve-table-container {
        height: 100% !important;
        max-height: 100% !important;
    }
    .ve-list-page__pagination {
        flex: 0 0 38px;
        min-height: 38px;
        overflow: hidden;
        display: flex;
        align-items: flex-start;
        background: white;
        font-size: 12px;
        padding-top: 3px;
        box-sizing: border-box;
    }

    .item-width  {
        height:20px;
        width: 32%;
    }
    .item-one {
        width: 97%;
        height:88px;
    }
    .pub_dialog {
        display: flex;
        justify-content: center;
        align-items: Center;
        overflow: hidden;
        .el-dialog {
            margin: 0 auto !important;
            height: 90%;
            overflow: hidden;
            .el-dialog__body {
                position: absolute;
                left: 0;
                top: 54px;
                bottom: 0;
                right: 0;
                padding: 0;
                z-index: 1;
                overflow: hidden;
                overflow-y: auto;
            }
        }
    }
</style>
<style lang="less">
    .custom-table-border .el-table__body td, .custom-table-border .el-table__header th {
        border-color: rgb(184, 181, 181);
        border-width: 1px;
    }
    .el-table {
        th {
            padding: 0 ;
        }
        thead{
            height: 15px;
            color:rgb(11, 11, 59);
            font-size:12px;
            background:rebeccapurple;
        }
        td {
            padding: 5px ;
            font-size:11px;
        } 
    }
    .el-dialog__body{
        padding: 10px;
    }
    .el-dialog__header{
        padding: 0px;
    }
    .el-dialog__footer{
        padding: 5px;
        border-top:1px solid #ccc;
    } 
    .el-dialog__headerbtn{font-size: 20px; background:white;top:5px !important;}
    //.el-dialog__headerbtn i { background:white;font-size: 20px;  }
    .el-table .success-row {
        color:#959997;
    }
    .el-table .cancel-row {
        color: #e00e66;
    }
    .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner::after{
        border-color :#3d77eb;
    }
    .el-checkbox__input.is-disabled+span.el-checkbox__label{
        color:#3d77eb
    }
    .messageBox .el-message-box__content{
        border-top: 1px solid #EBEEF5;
        height: 50px;
    }
    .el-message-box__message p{
        line-height: 30px;
    }
    .messageBox .el-message-box__btns{
        padding: 20px 15px 0;
    }
    .messageBox .el-message-box__header{
        background:#409eff;
    }
    .messageBox .el-message-box__title{
        color:white ;
        font-size:14px;
    }
</style>
